import classNames from 'classnames';
import { DateTime } from 'luxon';
import { FC, useState } from 'react';
import Button from '../../../../components/Button/Button';
import { ButtonVariants } from '../../../../components/Button/Button.types';
import Card from '../../../../components/Card/Card';
import Icon from '../../../../components/Icons/Icon';
import { FreezeType, GlobalFreeze } from '../../../../types/freeze.types';
import useConfirmationModal from '../../../../utils/useConfirmationModal/useConfirmationModal';
import DeleteConfirmationModal from '../../Bundles/BundleDetails/FreezeDetails/FreezeCard/DeleteConfirmationModal/DeleteConfirmationModal';
import styles from './GlobalFreezeCard.module.css';
import { useTranslation } from 'react-i18next';

interface GlobalFreezeCardProps extends GlobalFreeze {
  onEditClick: (id: string) => void;
}

const GlobalFreezeCard: FC<GlobalFreezeCardProps> = ({ id, name, startDate, endDate, live, onEditClick }) => {
  const { t } = useTranslation();
  const { open } = useConfirmationModal();
  const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] = useState(false);
  const openDeleteModal = () => setDeleteConfirmationModalOpen(true);
  const closeDeleteModal = () => setDeleteConfirmationModalOpen(false);

  const handleEditClick = () => {
    onEditClick(id);
  };

  return (
    <>
      <Card className={classNames(styles.card, { [styles.live]: live })}>
        {live && <div className={styles.liveBanner}>{t('common.live')}</div>}
        <div className={styles.freezeName}>{name}</div>
        <div className={styles.date}>
          <span>{t('common.startDate')}:</span>
          <span>{DateTime.fromISO(startDate).setZone('local').toFormat('f ZZZZ')}</span>
        </div>
        <div className={styles.date}>
          <span>{t('common.endDate')}:</span>
          <span>{DateTime.fromISO(endDate).setZone('local').toFormat('f ZZZZ')}</span>
        </div>
        <div className={styles.buttons}>
          <Button variant={ButtonVariants.Text} className={styles.editButton} onClick={handleEditClick}>
            <Icon iconName="Edit2" />
            {t('freezeCard.editFreezeButton')}
          </Button>
          <Button variant={ButtonVariants.Text} className={styles.deleteButton} onClick={openDeleteModal}>
            <Icon iconName="Trash" />
            {t('freezeCard.deleteButton')}
          </Button>
        </div>
      </Card>
      <DeleteConfirmationModal
        isOpen={deleteConfirmationModalOpen}
        onClose={closeDeleteModal}
        freezeType={FreezeType.GLOBAL_FREEZE}
        freezeName={name}
        startDate={startDate}
        endDate={endDate}
        idToDelete={id}
        openConfirmationModal={open}
      />
    </>
  );
};

export default GlobalFreezeCard;
